import * as React from 'react';
import { UIHeading3, UIText2 } from '@cian/ui-kit';
import * as styles from './style.css';
import { IDiscount } from '../../types/promoOffersSelection';

interface IPriceProps {
  price: string;
  discount?: IDiscount;
}

export const Price = ({ price, discount }: IPriceProps) => {
  if (discount) {
    return (
      <div className={styles['discount']}>
        <UIHeading3 as="h3">{discount.newPrice}</UIHeading3>
        <UIText2 as="span" color="text-secondary-default">
          {discount.oldPrice}
        </UIText2>
      </div>
    );
  }

  return <UIHeading3>{price}</UIHeading3>;
};
